(() => {
  if (window.hekayaCardSwipe) return;
  const selector = 'a[data-card-images]';
  const states = new WeakMap();
  const storageKey = 'hekaya:card-swipe:used';
  let used;
  try { used = new Set(JSON.parse(sessionStorage.getItem(storageKey) || '[]')); }
  catch (_) { used = new Set(); }
  let gesture = null;
  const keyFor = link => new URL(link.href, location.origin).pathname;
  function init(root = document) {
    root.querySelectorAll(selector).forEach(link => {
      let images;
      try { images = JSON.parse(link.dataset.cardImages); } catch (_) { return; }
      images = [...new Set(images.filter(src => typeof src === 'string' && src))];
      const img = link.querySelector('img');
      if (!img) return;
      img.draggable = false;
      link.draggable = false;
      const previous = states.get(link);
      const unchanged = previous && previous.img === img && JSON.stringify(previous.images) === JSON.stringify(images);
      if (previous && !unchanged) previous.request++;
      const state = unchanged ? previous : { images, img, index: 0, request: 0, suppressUntil: 0 };
      state.index = Number(link.dataset.swipeIndex || 0);
      states.set(link, state);
      // Section sorting can preserve nodes while replacing their server attributes.
      link.classList.toggle('hekaya-swipe-ready', images.length > 1);
      link.classList.toggle('hekaya-swipe-used', used.has(keyFor(link)));
    });
  }
  function dismiss(link) {
    used.add(keyFor(link));
    try { sessionStorage.setItem(storageKey, JSON.stringify([...used])); } catch (_) {}
    document.querySelectorAll(selector).forEach(other => {
      if (keyFor(other) === keyFor(link)) other.classList.add('hekaya-swipe-used');
    });
  }
  async function show(link, step) {
    const state = states.get(link);
    if (!state || state.images.length < 2) return;
    state.index = (state.index + step + state.images.length) % state.images.length;
    const request = ++state.request;
    // Secondary files load on demand, never with the initial grid.
    const image = new Image();
    image.decoding = 'async';
    image.src = state.images[state.index];
    try {
      await image.decode();
      if (state.request !== request || !link.isConnected) return;
      state.img.removeAttribute('srcset');
      state.img.src = image.src;
      link.dataset.swipeIndex = String(state.index);
      dismiss(link);
    } catch (_) {
      if (state.request === request) state.index = Number(link.dataset.swipeIndex || 0);
    }
  }
  document.addEventListener('pointerdown', event => {
    if (!event.isPrimary || event.button !== 0) return;
    const link = event.target.closest(selector);
    if (!link) return;
    if (!states.has(link)) init(link.parentElement);
    const state = states.get(link);
    if (!state || state.images.length < 2) return;
    state.suppressUntil = 0;
    gesture = { link, id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, axis: null };
  });
  document.addEventListener('pointermove', event => {
    const g = gesture;
    if (!g || event.pointerId !== g.id) return;
    const dx = event.clientX - g.x;
    const dy = event.clientY - g.y;
    if (!g.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 10) {
      if (Math.abs(dx) > Math.abs(dy) * 1.25) {
        g.axis = 'x';
        g.link.setPointerCapture(event.pointerId);
      } else if (Math.abs(dy) >= Math.abs(dx)) g.axis = 'y';
    }
    if (g.axis !== 'x') return;
    g.dx = dx;
    if (event.cancelable) event.preventDefault();
  }, { passive: false });
  function finish(event, cancelled) {
    const g = gesture;
    if (!g || event.pointerId !== g.id) return;
    gesture = null;
    if (g.axis === 'x') {
      states.get(g.link).suppressUntil = performance.now() + 650;
      if (!cancelled && Math.abs(g.dx) >= 30) {
        show(g.link, g.dx < 0 ? 1 : -1);
      }
    }
    if (g.link.hasPointerCapture(g.id)) g.link.releasePointerCapture(g.id);
  }
  document.addEventListener('pointerup', event => finish(event, false));
  document.addEventListener('pointercancel', event => finish(event, true));
  document.addEventListener('click', event => {
    const link = event.target.closest(selector);
    if (link && performance.now() < (states.get(link)?.suppressUntil || 0)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('dragstart', event => {
    if (event.target.closest(selector)) event.preventDefault();
  });
  document.addEventListener('hekaya:cards-rendered', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('pageshow', () => init());
  window.hekayaCardSwipe = { init };
  // Fudge debug controls: preview-only, no-ops live. See debug-ui guidance.
  function resetHints() {
    used.clear();
    try { sessionStorage.removeItem(storageKey); } catch (_) {}
    document.querySelectorAll('.hekaya-swipe-used').forEach(link => link.classList.remove('hekaya-swipe-used'));
  }
  window.__fudgeDebug?.action('إظهار تلميحات السحب من جديد', resetHints);
  window.__fudgeDebug?.command('Reset swipe hints', resetHints);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
